import { connect } from 'react-redux';

import PressureTabs from '../../components/SensorsTabs/Pressure/PressureTabs';
import * as actionsPressure from '../../actions/SensorsPressureActions';

const mapStateToProps = (state, ownProps) => {
    const readingData = state.leaksList.pressure?.readingData || { data: [], isFetching: false, hoursBack: 0 };
    const transientsData = state.leaksList.pressure?.transientsData || { data: [], isFetching: false };
    const transientThresholds = state.leaksList.pressure?.transientThresholds || { med: 20, high: 30 };
    const selectedProject = state.leaksList.selectedProject;
    const loggerId = ownProps.sensorItem?.aqs_logger_id;
    const pressureSensorsData = state.leaksList.leaksByProject[selectedProject]?.sensors?.pressureSensors || {};
    const pressureAlarms = pressureSensorsData.alarms || [];
    const pressureSensors = pressureSensorsData.items || [];
    const lastPressureSample = state.leaksList.leaksByProject[selectedProject]?.sensors?.pressureSensors?.samples?.[0]
    const projectTimezone = state.leaksList.leaksByProject[selectedProject]?.projectDetails?.time_zone;
    const pressureUnit = state.local.pressureUnit || 'meter';

    return {
        projectId: selectedProject,
        loggerId,
        readingData: readingData.data || [],
        isFetching: readingData.isFetching || false,
        hoursBack: readingData.hoursBack || 0,
        lastPressureSample,
        pressureAlarms,
        transients: transientsData.data || [],
        transientThresholds,
        timeZone: state.local.timeZone,
        projectTimezone,
        pressureUnit,
        pressureSensors,
        ...ownProps
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchReading: (projectId, loggerId, hoursBack) => {
            dispatch(actionsPressure.fetchPressureReading(projectId, loggerId, hoursBack));
        },
        fetchTransients: (projectId, loggerId) => {
            dispatch(actionsPressure.fetchPressureTransients(projectId, loggerId));
        },
        fetchPressureSettings: (projectId) => {
            dispatch(actionsPressure.fetchPressureSettings(projectId));
        },
        fetchTransientReading: (projectId, sensorId, readingId) => {
            return dispatch(actionsPressure.fetchPressureTransientReading(projectId, sensorId, readingId))
        },
        fetchMultiDayReading: (projectId, loggerId, startDate, endDate) => {
            return dispatch(actionsPressure.fetchMultiDayReading(projectId, loggerId, startDate, endDate));
        },
        fetchMultiDayTransients: (projectId, loggerId, startDate, endDate) => {
            return dispatch(actionsPressure.fetchMultiDayTransients(projectId, loggerId, startDate, endDate));
        },
        fetchPressureAlarmsForSensor: (projectId, loggerId) => {
            return dispatch(actionsPressure.fetchPressureAlarmsForSensor(projectId, loggerId));
        }
    };
};

const cSensorPressureTabs = connect(
    mapStateToProps,
    mapDispatchToProps
)(PressureTabs);

export default cSensorPressureTabs;
